
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/productFile",
      function () {
        return require("private-next-pages/productFile/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/productFile"])
      });
    }
  